import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { LiveFeedCard, NewsGroup, NewsHeader } from "../../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../../utils/environment";
import { getTodayLiveFeed } from "../../../liveFeed/service/liveFeed.service";
import { AnimatePresence, motion } from "framer-motion";

const lan = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [liveFeedList, setLiveFeedList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    async function fetchPageData() {
      try {
        const getLiveFeed = await getTodayLiveFeed();
        if (getLiveFeed?.data) {
          setLiveFeedList(getLiveFeed?.data?.news || []);
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setIsLoading(false);
      }
    }
    setIsLoading(true);
    fetchPageData();
  }, []);

  useEffect(() => {
    if (liveFeedList.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % liveFeedList.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [liveFeedList]);

  return (
    <>
      {/* {liveFeedList && liveFeedList?.length > 0 && (
        <NewsGroup
          data={{
            titleName: "Live Feed",
            linkName: "",
            type: "en",
          }}
        >
          <div className="news-row">
            {Array.isArray(liveFeedList) && liveFeedList.length > 0 ? (
              <AnimatePresence mode="wait">
                <motion.div
                  key={currentIndex}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.6 }}
                  className="motion-card-wrapper"
                >
                  <LiveFeedCard
                    data={{
                      title: liveFeedList[currentIndex]?.title[lan],
                      date: liveFeedList[currentIndex]?.created_at,
                      tags: liveFeedList[currentIndex]?.tags,
                    }}
                  />
                </motion.div>
              </AnimatePresence>
            ) : (
              <div className="error-message">No Live Feed Found</div>
            )}
          </div>
        </NewsGroup>
      )} */}
      {liveFeedList && liveFeedList?.length > 0 && (
        <div className={"live-news-wrapper"}>
          <div className="lnw__badge">
            <span className="lnw__dot"></span>
            <span className="lnw__text">Live</span>
          </div>
          <div className={"lnw__headers-bg"}>
            <div className={"lnw__news-ticker"}>
              {/* <div className={"lnw__headers"}> */}
              {Array.isArray(liveFeedList) && liveFeedList.length > 0 ? (
                <AnimatePresence mode="wait">
                  <motion.div
                    key={currentIndex}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.6 }}
                    className="motion-card-wrapper"
                  >
                    <NewsHeader
                      key={currentIndex}
                      data={{
                        newsContent: liveFeedList[currentIndex]?.title[lan],
                        url: liveFeedList[currentIndex]?.url,
                      }}
                      onClick={() => {
                        window.open(liveFeedList[currentIndex]?.url);
                      }}
                    />
                    {/* <LiveFeedCard
                      data={{
                        title: liveFeedList[currentIndex]?.title[lan],
                        date: liveFeedList[currentIndex]?.created_at,
                        tags: liveFeedList[currentIndex]?.tags,
                      }}
                    /> */}
                  </motion.div>
                </AnimatePresence>
              ) : (
                <div className="error-message">No Live Feed Found</div>
              )}
              {/* </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(Index);
